<template>
    <div class="title">
      OWB1:
      <span v-if="!edit">{{ heart_rate_zone }} <span v-if="runner.real_heart_rate_zone">bpm</span><span v-else>min/km</span>
            <rp-icon
              type="edit"
              tooltip="edytuj"
              v-if="isActiveRunnerTrainer && !runner.real_heart_rate_zone"
              @click="edit=true"
            />
      </span>
      <v-form v-if="edit" @submit.prevent="save" novalidate class="d-inline-block">
        <v-text-field
            class="d-inline-block"
            v-model="form.heart_rate_zone"
        />
        min/km
        <v-btn icon
            type="submit"
            v-tooltip="'Zapisz'"
        >
          <v-icon

          color="grey darken-1"
            >
            save
          </v-icon>
        </v-btn>
        <rp-icon
          type="clear"
          tooltip="anuluj"
          @click="edit=false"
        />
      </v-form>
    </div>
</template>

<script>
import {patchRunnerTrainer} from './api'
import iziToast from 'izitoast'
import { mapState, mapGetters } from 'vuex'
import * as types from '@/store/mutation-types'

export default {
  data () {
    return {
      edit: false,
      form: {
      }
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['isActiveRunnerTrainer']),
    heart_rate_zone () {
      return this.runner.real_heart_rate_zone || this.runner.heart_rate_zone || 'brak'
    }
  },
  created () {
    this.form = this.runner
  },
  methods: {
    save () {
      patchRunnerTrainer(this.runner.trainer, {'id': this.runner.id, 'heart_rate_zone': this.form.heart_rate_zone}).then((data) => {
        this.$emit('runner-changed', data)
        iziToast.show({
          message: 'OWB1 został edytowany',
          color: 'green'
        })
        this.$store.commit(types.RUNNER_SUCCESS, data)
        this.edit = false
      }).catch((data) => {
        if (data.response.status === 400) {
          iziToast.show({
            message: 'Nie udało się edytować',
            color: 'red'
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerHeartRate.vue